Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useStyles = void 0;
var _reactNative = require("react-native-web");
var _styles = require("../../../../../styles");
var useStyles = exports.useStyles = function useStyles() {
  var _STYLES$useStyles = _styles.STYLES.useStyles(),
    bp = _STYLES$useStyles.bp,
    spacing = _STYLES$useStyles.spacing;
  var title = {
    fontSize: _styles.STYLES.fontSize.normal,
    lineHeight: _styles.STYLES.lineHeight.normal,
    maxWidth: _styles.STYLES.grid.maxBoxWidth,
    marginBottom: spacing.l
  };
  if (bp.is([bp.mobile_l, bp.mobile_xl])) {
    title.fontSize = _styles.STYLES.fontSize.l;
    title.lineHeight = _styles.STYLES.lineHeight.l;
  }
  if (bp.is([bp.tablet, bp.desktop])) {
    title.fontSize = _styles.STYLES.fontSize.xl;
    title.lineHeight = _styles.STYLES.lineHeight.xl;
  }
  if (bp.tablet) {
    title.marginBottom = spacing.xl;
  }
  if (bp.desktop) {
    title.marginBottom = spacing.xxl;
  }
  var styles = _reactNative.StyleSheet.create({
    title: title
  });
  return {
    styles: styles
  };
};